var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pages.length
    ? _c(
        "div",
        {
          staticClass:
            "flex justify-center text-xl items-center mt-5 px-1_5 md_px-0"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "select-none mr-3 cursor-pointer hover_underline whitespace-no-wrap",
              class: { "opacity-75 pointer-events-none": _vm.page == 1 },
              on: {
                click: function($event) {
                  return _vm.goToPage(_vm.page - 1)
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.goToPage(_vm.page - 1)
                }
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "inline align-middle mr-_5",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "8",
                    height: "13",
                    viewBox: "0 0 8 13"
                  }
                },
                [
                  _c("path", {
                    staticClass: "stroke-current",
                    attrs: {
                      fill: "none",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-miterlimit": "50",
                      d: "M7 1v0L1 6.5v0L7 12v0"
                    }
                  })
                ]
              ),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Prev")])
            ]
          ),
          _vm._l(_vm.pages, function(pageNumber) {
            return _c(
              "div",
              {
                staticClass:
                  "select-none h-2_75 w-2_75 flex items-center justify-center cursor-pointer hover_underline",
                class: {
                  "bg-brand text-white hover_no-underline":
                    _vm.page == pageNumber ||
                    (pageNumber === 1 && _vm.isUndefined(_vm.page))
                },
                on: {
                  click: function($event) {
                    return _vm.goToPage(pageNumber)
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.goToPage(pageNumber)
                  }
                }
              },
              [_vm._v(_vm._s(pageNumber))]
            )
          }),
          _c(
            "div",
            {
              staticClass:
                "select-none ml-3 cursor-pointer hover_underline whitespace-no-wrap",
              class: {
                "opacity-75 pointer-events-none": _vm.page == _vm.maxPages
              },
              on: {
                click: function($event) {
                  _vm.goToPage(parseInt(_vm.page) + 1)
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  _vm.goToPage(parseInt(_vm.page) + 1)
                }
              }
            },
            [
              _c("span", { staticClass: "align-middle" }, [_vm._v("Next")]),
              _c(
                "svg",
                {
                  staticClass: "inline align-middle ml-_5",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "8",
                    height: "13",
                    viewBox: "0 0 8 13"
                  }
                },
                [
                  _c("path", {
                    staticClass: "stroke-current",
                    attrs: {
                      fill: "none",
                      stroke: "#595959",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-miterlimit": "50",
                      d: "M1 1v0l6 5.5v0L1 12v0"
                    }
                  })
                ]
              )
            ]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }